// The extension of an uploaded asset, which becomes the resource's editable Filetype field.
//
// It reads the extension only when the extension ends the url. The Angular expression also had an
// alternative for an extension followed by a query string or a fragment, but it read the first
// capture group only, so that alternative never produced a value. A url with a query string has
// always yielded an empty type here, which an admin then fills in by hand.
const EXTENSION_PATTERN = /\.(.{3,4})$/i;

export function fileTypeForUrl(url: string | null | undefined): string {
    const matches = (url || '').match(EXTENSION_PATTERN);
    return matches?.[1] || '';
}
